export const inputTextRegexp = /^[A-Za-z0-9ñÑáéíóúüÁÉÍÓÚÜ.][A-Za-z0-9ñÑáéíóúüÁÉÍÓÚÜ.\s]*$/;
